<template>
 <svg width="129" height="4" viewBox="0 0 129 4" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.5" width="128" height="4" rx="2" fill="#B2BBC7"/>
</svg>

    </template>
    
    